import { type Action, type AnyAction } from '@reduxjs/toolkit'
import {
  handleLogin as authLogin,
  handleLogout as authLogout,
} from '@wellesley/auth'
import { remoteLogin, remoteLogout } from '../../api/actions'

const remoteApi = {
  [remoteLogin.type]: () => authLogin(),
  [remoteLogout.type]: () => authLogout(),
}

const isRemoteApiAction = (action: Action) =>
  Object.keys(remoteApi).includes(action.type)

export const callRemoteApiAction = (action: AnyAction) => {
  if (isRemoteApiAction(action) && action.type in remoteApi) {
    return (remoteApi[action.type as keyof typeof remoteApi] as () => void)()
  }
  return null
}
